import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ButtonBase from '../ButtonBase';
const Root = styled.div.withConfig({
  displayName: "ButtonGroup__Root",
  componentId: "sc-1iginm8-0"
})(["display:inline-flex;> ", " + ", ",> * + *{margin-left:var(--size-spacing-03);}"], ButtonBase.Style, ButtonBase.Style);
const ButtonGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const childrenArray = React.Children.toArray(children);
  const buttons = childrenArray.map((child, index) => {
    const state = {
      index,
      tabIndex: 0,
      className: "".concat(child.props.className, " button-group__child")
    };
    return /*#__PURE__*/React.cloneElement(child, Object.assign({}, child.props, state, {
      key: child.key || index
    }));
  });
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    role: "group"
  }, rest), buttons);
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.Style = Root;
process.env.NODE_ENV !== "production" ? ButtonGroup.propTypes = {
  /**
   * Should be two or more of `<Button />`, `<IconButton />` or `<LinkButton />`
   */
  children: PropTypes.node.isRequired
} : void 0;
export default ButtonGroup;